module.exports = __webpack_public_path__ + "static/media/logodatalife_menuapp.734cb74c.svg";